import { combineReducers } from 'redux'
import captions from './captionsReducer'
import content from './contentReducer'
import deeplink from './deeplinkReducer'
import device from './deviceReducer'
import loading from './loadingReducer'
import overlay from './overlayReducer'
import personalization from './personalizationReducer'
import screensaver from './screensaverReducer'
import search from './searchReducer'
import station from './stationReducer'
import ui from './uiReducer'
import user from './userReducer'
import homeContent from './homeContentReducer'
import error from './errorReducer'
import multilivestream from './multilivestreamReducer'
import showDetail from './showReducer'

export default combineReducers({
  captions,
  overlay,
  loading,
  content,
  deeplink,
  ui,
  device,
  station,
  user,
  search,
  personalization,
  screensaver,
  homeContent,
  error,
  multilivestream,
  showDetail,
})
